import React from "react";
import { AnimateIn } from "./AnimateIn";
import "./TrustBar.css";

export const TrustBar = () => {
  return (
    <section className="trustbar-section">
      <AnimateIn variant="fadeUp">
        <div className="section-container">
          {/* Hero metric + partner */}
          <div className="trust-metrics">
            <div className="trust-metric">
              <span className="trust-metric-number">
                40<span className="trust-metric-plus">+</span>
              </span>
              <div className="trust-metric-text">
                <span className="trust-metric-label">社にご利用いただいています</span>
                <span className="trust-metric-sub">製薬・医療・研究機関を中心に導入が進んでいます</span>
              </div>
            </div>
            <span className="trust-metric-divider" />
            <div className="trust-partner">
              <span className="trust-partner-label">提供・共同開発パートナー</span>
              <a
                href="https://www.k-idea.jp/"
                target="_blank"
                rel="noopener noreferrer"
                className="trust-partner-link"
              >
                <img src="/img/logos/k-idea.png" alt="K-idea / 木村情報技術株式会社" className="trust-partner-logo" />
              </a>
            </div>
          </div>
          <p className="trust-metrics-note">※トライアル申込中の企業を含みます</p>
        </div>
      </AnimateIn>
    </section>
  );
};
